export const enums = {
    tipoRecoleccion: {
        comercial: 1,
        residencial: 2,
        ocurre: 3,
    },
    estatusCotizacion: {
        // inicial: 0,
        datosClienteInv: 0.5,
        proyecto: 1,
        origenDestino: 2,
        datosMercancia: 3,
        serviciosAdicionales: 4,
        datosCliente: 5,
        tipoEnvio: 6,
        markup: 7,
        cotizacion: 8,
        resumen: 9,
        registroUsuario: 99

    },
    estatusSolicitud: {
        inicial: 0,
        datosClienteInv: 0.5,
        proyecto: 1,
        facturador: 1.1,

        origenDestino: 2,
        datosMercancia: 3,
        serviciosAdicionales: 4,
        datosCliente: 5,
        tipoEnvio: 6,
        markup: 7,
        cotizacion: 8,
        resumen: 9,
        registroUsuario: 99
    },
    pais: {
        mexico: 1,
        usa: 2,
    },
    unidadMedidaLongitud: {
        metros: 3,
        pulgadas: 4,
    },
    unidadMedidaPeso: {
        kilos: 1,
        libras: 2,
    },
    servicioAdicional: {
        retornoDocumentos: 5
    },
    seguro: {
        basico: 1,
        declarado: 2,
    },
    parametro: {
        seguroBasicoCobro: 1,
        seguroBasicoCubre: 2,
        seguroDeclaradoMinimo: 3,
        seguroDeclaradoMaximo: 4,
        kilogramoLibra: 24,
        metroPulgada: 56,
        AplicaAreaServicioPuertoAeropuertoCartaPorte: 126
    },
    tipoPersona: {
        particular: 1,
        empresa: 2
    },
    tipoPersonaRazonSocial: {
        fisica: 1,
        moral: 2,
        particular: 3,
        gubernamental: 4,
        extranjero: 5,
    },
    tipoCosto: {
        cantidad: 1,
        unicoPorCantidad: 6
    },
    tipoRfc:{
        extranjero: 'XEXX010101000',
        particular: 'XAXX010101000'
    },
    tipoPago:{
        credito: 1,
        contado: 2
    },
    tipoDocumento:{
        cotizacion:1,
        solicitudservicio:2
    },
    tipoComercioExterior:{
        puerto:1,
        aeropuerto:2,
        internacional:3
    },
    tipoMovimientoServicioInternacional:{
        northbound:1,
        southbound:2
    }
};
